import { Divider, Drawer, Space, Button, Radio, Checkbox, Slider } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { apiCall } from "../../../utils/Api";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";

export default function GiftCards(props) {

    const [template,] = useTemplate();
    const [loading, setLoading] = useState(false);
    const [cards, setCards] = useState([]);
    const { edit = false, close = () => { }, saveItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);

    const [l, setL] = useState(false)
    const [r, setR] = useState(false);
    const [w, setW] = useState(false);

    const fetchCards = () => {
        setLoading(true);
        apiCall("giftcard/getSettings", {}, (_status, _result) => {
            if (_status) {
                setCards(_result.cards.filter(item => item.active));
            }
            setLoading(false);
        })
    }

    useEffect(fetchCards, []);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        width = 800,
        align = "0 auto",
        radius = 15,
        padding_x = 20,
        padding_y = 20,
        gap = 20,
        shadow = true,
        button_type = 0,
        text_preset = 0,
        background_colour = 0,
        card_width = 50,
    } = data;


    const save = () => {
        close();
        saveItem(id, { ...content })
    }

    const marks = {
        800: <small>800px</small>,
    };


    const drawCards = () => {

        let _style = {
            flexGrow: 1,
        }

        let bg_style = {

        }

        let containerStyle = {
            width: width + "px",
            border: (w) ? "4px solid deeppink" : "none",
            maxWidth: "100%",
            margin: align,
        }

        let _stack = "row";

        if (props.view === "phone") {
            _stack = "column-reverse";
        }


        if (r) {
            bg_style.borderRight = "4px solid deeppink";
        }

        let _wrap = {
            margin: align,
            maxWidth: width + "px",
            background: getColor(background_colour, template)
        }

        return cards.map(item => {
            return (
                <div style={_wrap}>
                    <div style={{ background: getColor(background_colour, template), padding: padding_y + "px " + padding_x + "px" }}>
                        <div style={containerStyle}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: _stack, gap: gap + "px" }}>
                                <div style={{ ...bg_style, flex: '0 0 ' + card_width + "%", display: 'flex' }}>
                                    <img onError={i => i.target.style.display = 'none'} style={{ "width": "100%", "borderRadius": radius + "px", "boxShadow": (shadow) ? "0px 2px 5px 0px rgba(0,0,0,0.5)" : "none" }} src={"https://bookmanager.com/i/m.php?b=" + item.encrypted_code} />
                                </div>
                                <div style={{ flex: '0 0 ' + (100 - card_width) + "%", display: 'flex', justifyContent: align }}>
                                    <div style={{ ..._style, border: (l) ? "4px solid deeppink" : "none" }}>
                                        <div>
                                            <h4 className={"bm-txt-" + text_preset}>{item.description}</h4>
                                            <div className="shim" />
                                            <Button className={"bm-btn-" + button_type}>Add to Cart</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    const drawRender = () => {
        let _wrap = {
            margin: align,
            maxWidth: width + "px",
        }
        return (
            <>
                <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                    <div style={{ "backgroundColor": getColor(background_colour, template, "#ffffff00") }}>
                        <div style={_wrap}>
                            <div className="shim" style={{ "height": padding_y + "px" }} />
                            {drawCards()}
                            <div className="shim" style={{ "height": padding_y + "px" }} />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const tipFormatter = (value) => {
        const remaining = 100 - value;
        return `${value} / ${remaining}`;
    };

    const splitmarks = {
        25: <small>25/75</small>,
        50: <small>50/50</small>,
        75: <small>75/25</small>,
    };

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => close()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* CONTAINER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LAYOUT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={container} onChange={(e) => setContent({ ...content, "container": e.target.value })} >
                            <Radio value={false}><small>100% of the screen width</small></Radio>
                            <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH</Divider>
                <Slider
                    style={{ "width": "150px" }}
                    min={0}
                    max={1248}
                    marks={marks}
                    onChange={(_v) => setData({ ...data, "width": _v })}
                    value={width}
                />

                {/* SPLIT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE & TEXT SPLIT</Divider>
                <div className="float-flex">
                    <div className="simple-label"><div className="shim" /><div className="shim" />IMAGE</div>
                    <Slider
                        className="rail"
                        onBeforeChange={() => { setR(true); setW(true) }}
                        onAfterChange={() => { setR(false); setW(false) }}
                        marks={splitmarks}
                        style={{ "width": "160px" }}
                        tipFormatter={tipFormatter}
                        min={20}
                        max={80}
                        onChange={(_v) => setData({ ...data, "card_width": _v })}
                        value={card_width}
                    />
                    <div className="simple-label"><div className="shim" /><div className="shim" />TEXT</div>
                </div>


                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                <Space>
                    <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                    <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    <div><PicRightOutlined onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                </Space>
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAP</Divider>
                <Space>
                    <BMInput width={35} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                    <BMInput width={35} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                    <BMInput width={35} value={gap} onChange={(_v) => setData({ ...data, "gap": _v })} number min={0} max={100} prefix="GAP" />
                </Space>
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CARD RADIUS / SHADOW</Divider>
                <div className="float-flex">
                    <BMInput width={"40px"} value={radius} onChange={(e) => setData({ ...data, "radius": e })} number min={0} max={1000} prefix="R" />
                    <Checkbox checked={shadow} onClick={(e) => setData({ ...data, "shadow": e.target.checked })}><small>Shadow?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CARD TITLE PRESET</Divider>
                <PresetPicker value={text_preset} onChange={(e) => setData({ ...data, "text_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON PRESET</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }
    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}